import type { Subscription, SubscriptionAddress } from '../subscriptions.api'

export const formatCardMasked = (masked: string | undefined) => {
    if (!masked) return 'xxxx - xxxx - xxxx - xxxx'
    return `xxxx - xxxx - xxxx - ${masked.slice(-4)}`
}

export const formatMoney = (currency: string, amount: number) => `${currency} ${amount.toLocaleString()}`

export const formatShipping = (currency: string, amount: number, freeLabel: string) => (amount === 0 ? freeLabel : formatMoney(currency, amount))

export const getOperatingSystemName = () => {
    const userAgent = navigator.userAgent
    if (/Win/i.test(userAgent)) return 'Windows'
    if (/Mac/i.test(userAgent)) return 'MacOS'
    if (/iPhone|iPad/i.test(userAgent)) return 'iOS'
    if (/Android/i.test(userAgent)) return 'Android'
    return 'Unknown'
}

export const formatAddressFallback = (shipToAddress: SubscriptionAddress) =>
    [shipToAddress.address1, shipToAddress.address2, shipToAddress.city, shipToAddress.state, shipToAddress.zip, shipToAddress.country]
        .filter(Boolean)
        .join(', ')

export const buildCancelItems = (subscription: Subscription) =>
    subscription.lines.items.reduce<Record<string, { qty: number; price: number }>>((items, lineItem) => {
        items[lineItem.item.id.unicity] = {
            qty: lineItem.quantity,
            price: lineItem.terms.priceEach
        }
        return items
    }, {})

export const buildSkipItems = (subscription: Subscription) =>
    subscription.lines.items.map(lineItem => ({
        item_code: lineItem.item.id.unicity,
        qty: lineItem.quantity,
        price: lineItem.terms.priceEach
    }))

export const buildEditItems = (subscription: Subscription) =>
    subscription.lines.items.map(lineItem => ({
        item_code: lineItem.item.id.unicity,
        qty: lineItem.quantity,
        price: lineItem.terms.priceEach
    }))

export const getSubscriptionBaId = (subscription: Subscription, fallbackBaId: string) => String(subscription.customer?.id?.unicity ?? fallbackBaId)
